module.exports = __webpack_public_path__ + "img/shin-nosuke.3964aba5.jpg";